import React from 'react';
import ReactDOM from 'react-dom/client';
import { AdminRpaApp } from './AdminRpaApp';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { getMsalConfig } from "./helpers/authConfig";

import './i18n';

const msalInstance = new PublicClientApplication(getMsalConfig());
console.log("msalInstance: ", msalInstance)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MsalProvider instance={msalInstance}>
        <AdminRpaApp />
    </MsalProvider>
);

reportWebVitals();
serviceWorkerRegistration.unregister();